import { useEffect, useState } from 'react';
import i18n from 'i18n/config';
import { Col } from 'reactstrap';
import { useDebounce } from 'hooks/useDebounce';
import { formatSearchPlaceholder } from '../utils/formatSearchPlaceholder';

const SearchBar = ({
  searchBy,
  placeholder = '',
  onSearch,
  initialValue = '',
}) => {
  const [searchTerm, setSearchTerm] = useState(initialValue);
  const debouncedSearchTerm = useDebounce(searchTerm, 500);

  const handleChangeText = (e) => {
    setSearchTerm(e.target.value);
  };

  useEffect(() => {
    if (debouncedSearchTerm === '' || debouncedSearchTerm.length >= 2) {
      onSearch(debouncedSearchTerm);
    }
  }, [debouncedSearchTerm, onSearch]);

  return (
    <Col className="col-6 text-left" sm="4">
      <div
        id="DataTables_Table_0_filter"
        className="dataTables_filter d-flex-inline"
      >
        <div className="form-control-wrap">
          <div className="form-icon form-icon-left">
            <em className="icon ni ni-search" />
          </div>
          <input
            type="search"
            value={searchTerm}
            className="form-control bg-transparent border-light"
            placeholder={formatSearchPlaceholder(placeholder || searchBy, i18n)}
            onChange={handleChangeText}
          />
        </div>
      </div>
    </Col>
  );
};

export default SearchBar;
